module.exports = __webpack_public_path__ + "img/banner03.63259cd0.jpg";